<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <material-card icon="mdi-clipboard-text" inline title="B2S Configuration">
          <v-card-component>
            <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
              <v-spacer></v-spacer>
              <v-text-field
                :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                v-model="search"
                append-icon="mdi-magnify"
                class="ml-auto mb-2"
                label="Search"
                hide-details
                single-line
                style="max-width:350px;"
              />
              <v-btn elevation="1" @click="addNewConfiguration()" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
                <v-icon left>mdi-plus</v-icon>
                Add New
              </v-btn>
            </v-card-text>

            <v-divider class=" my-0 " />
            <v-data-table
              :footer-props="{
                'items-per-page-options': [5, 10, 20, 40]
              }"
              item-key="srno"
              :items-per-page="5"
              :headers="headers"
              :items="enquiryStageData"
              :search="search"
              id="id"
            >
              <template v-slot:item.statusName="{ item }">
                <span>{{ item.statusName || '-' }}</span>
              </template>

              <template v-slot:item.name="{ item }">
                <span>{{ item.name }}</span>
              </template>
              <template v-slot:item.callAttemptCount="{ item }">
                <span>{{ item.callAttemptCount }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <router-link color="success" :to="{ name: 'EditEnquiryStage', params: { stageID: item.id } }">
                  <v-btn class="px-2 ml-1 white--text ma-1" color="info" min-width="0" small>
                    Edit
                  </v-btn>
                </router-link>
              </template>
            </v-data-table>
          </v-card-component>

          <v-card-component>
            <section class="section is-title-bar">
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <p class="title is-5">Auto allocation Configuration</p>
                  </div>
                </div>
              </div>
            </section>
            <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }"> </v-card-text>

            <v-divider class=" my-0 " />
            <v-data-table
              :footer-props="{
                'items-per-page-options': [5, 10, 20, 40]
              }"
              item-key="srno"
              :items-per-page="5"
              :headers="allocationHeaders"
              :items="autoAllocationData"
              :search="search"
              id="id"
            >
              <template v-slot:item.actions="{ item }">
                <router-link color="success" :to="{ name: 'EditAutoAllocationConfig', params: { allocationId: item.id } }">
                  <v-btn class="px-2 ml-1 white--text ma-1" color="info" min-width="0" small>
                    Edit
                  </v-btn>
                </router-link>
              </template>
            </v-data-table>
          </v-card-component>
        </material-card>
      </v-col>
      <loading-icon :value="isLoading" />
    </v-row>
  </v-container>
</template>
<script>
import stores from '@/stores'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'

export default {
  name: 'B2SConfiguration',
  components: {
    MaterialCard,
    VCardComponent
  },
  data () {
    return {
      user: stores.user.me,
      userID: '',
      isWrite: false,
      dialog: false,
      item: 0,
      enquiryStageData: [],
      autoAllocationData: [],
      enquiryStageID: '',
      radio: 'all',
      total: 0,
      search: '',
      headers: [
        { text: 'Stage', value: 'statusName', sortable: true },
        { text: 'Sub stage', value: 'name', sortable: true },
        { text: 'Call Attempt Count', value: 'callAttemptCount', sortable: true },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ],
      allocationHeaders: [
        { text: 'Auto Allocation cut off', value: 'autoAllocationCutOff', sortable: true },
        { text: 'Fresh leads', value: 'freshLeads', sortable: true },
        { text: 'Followup leads', value: 'followUpLeads', sortable: true },
        { text: 'Max lead count', value: 'maxLeadCount', sortable: true },
        { text: 'Setting date', value: 'settingDate', sortable: true },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ],
      isLoading: false,
      loadingComponent: null,
      currentAssignedUser: '',
      enquiryTableData: [],
      findDataArr: [],
      searchKey: '',
      inProgress: false,
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      stages: []
    }
  },

  async created () {
    await this.getAllEnquiryStages()
    await this.getAutoAllocationConfig()
  },

  methods: {
    addNewConfiguration: async function () {
      this.$router.push({ name: 'addNewSettings' })
    },
    getAllEnquiryStages: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/get-allenquirystages`)
        this.enquiryStageData = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry stage data : ', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getAutoAllocationConfig: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/autoallocationconfig`)
        this.autoAllocationData = data.filter(e => {
          e.settingDate = moment(e.settingDate).format('DD-MMMM-YYYY HH:MM:SS')
          return e
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry stage data : ', errorMessage)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="css">
.click-card {
  cursor: pointer;
}
</style>
